import { render, staticRenderFns } from "./ac-bulk-actions.vue?vue&type=template&id=0d70dfef&scoped=true&"
import script from "./ac-bulk-actions.vue?vue&type=script&lang=js&"
export * from "./ac-bulk-actions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d70dfef",
  null
  
)

export default component.exports